import { useRef, useEffect } from 'react';

function DashboardServiceTermsJaJP() {
  // Construct the static assets path properly
  const getStaticPath = () => {
    const publicUrl = import.meta.env.VITE_PUBLIC_URL || '';
    // Remove trailing slash if present
    const cleanPublicUrl = publicUrl.replace(/\/$/, '');
    // Add /static to the end
    return `${cleanPublicUrl}/static`;
  };

  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.body.style =
          'margin: auto; -moz-transform: scale(2); zoom: 2;';
      }
    };

    iframe.contentWindow.addEventListener('load', handleLoad);

    return () => {
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.removeEventListener('load', handleLoad);
      }
    };
  }, []);

  return (
    <iframe
      title="Dashboard Service Terms"
      src={`${getStaticPath()}/serviceTerms/serviceTerms.html`}
      ref={iframeRef}
      width="100%"
      height="100%"
    />
  );
}

export default DashboardServiceTermsJaJP;
